import { render, staticRenderFns } from "./Cari.vue?vue&type=template&id=28068cde&lang=true&"
import script from "./Cari.vue?vue&type=script&lang=js&"
export * from "./Cari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports